import { render, staticRenderFns } from "./SidebarNavItem.vue?vue&type=template&id=6f7bdfe9&scoped=true"
import script from "./SidebarNavItem.vue?vue&type=script&lang=js"
export * from "./SidebarNavItem.vue?vue&type=script&lang=js"
import style0 from "./SidebarNavItem.vue?vue&type=style&index=0&id=6f7bdfe9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7bdfe9",
  null
  
)

export default component.exports